import { css } from "lit";

export const suggestionList = css`
  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    border-radius: 5px;
    box-shadow: 0 2px 4px 1px rgb(0 0 0 / 50%);
    margin: 4px 0 0 -2px;
    border: 2px solid #ff206e;
    background-color: #fff;
    width: 100%;
    padding: 0;
    box-sizing: content-box;
    z-index: 1000;
  }
  .dropdown-menu li a {
    text-decoration: none;
    color: #2b2b2b;
    outline: 0;
    display: block;
    font-size: 14px;
    padding: 9px 19px;
    line-height: 16px;
    height: auto;
    cursor: pointer;
    white-space: nowrap;
  }
  .dropdown-menu li a:hover,
  .dropdown-menu .active a {
    background-color: #ff206e;
    color: #ffffff;
  }
`